export default {"src":"/_next/static/media/Circle1.9742de79.svg","height":567,"width":570,"blurWidth":0,"blurHeight":0};